module.exports = __webpack_public_path__ + "img/olho.80012380.svg";